@if (dataIsLoaded && !marketIn('zhs-CN')) {
  <div [@fadeInFooter]="showFooter ? 'shown' : 'hidden'">
    <div class="logo-container">
      <img
        class="img-fluid"
        src="logo/usana_logo_white.svg"
        alt="{{ 'footer.usanaLogo.text' | i18n: 'usanadotcom' }}"
        height="132"
        width="150"
      />
    </div>
    <div class="container">
      <div class="row footer-links">
        @for (item of data.items; track item; let i = $index) {
          <div class="footer-link-column col-md-3" [class.col-md-4]="marketIn('enu-IN')">
            <a
              class="column-title"
              (click)="isCollapsed[i] = !isCollapsed[i]"
              tabindex="0"
              data-testid="footerMenuItem"
            >
              {{ item.name }} <i class="fa-regular fa-angle-down"></i>
            </a>
            <div [(ngbCollapse)]="isCollapsed[i]">
              @for (child of item.children; track child) {
                <div class="children">
                  @if (hasInnerText(child.name | trim) && childInMarket(child)) {
                    <a
                      [attr.data-testid]="urlPathId(child.name)"
                      [appLink]="child.url"
                      [target]="child.target === '_blank' ? '_blank' : '_self'"
                      (click)="onFooterLinkClicked(child)"
                    >
                      {{ child.name }}
                    </a>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (!marketIn('enu-IN')) {
          <div class="footer-link-column col-md-3">
            <div class="column-title">{{ data.followText }}</div>
            @for (social of data.socialMedia; track social; let i = $index) {
              @if (social.social | trim) {
                <a
                  href="{{ social.url }}"
                  class="social-media-footer-link"
                  target="_blank"
                  rel="noopener"
                  [attr.aria-label]="social.social"
                  [attr.data-testid]="social.social"
                >
                  <i class="fa-brands fa-lg fa-{{ social.social }}"></i>
                </a>
              }
            }
            <a
              class="logo-link"
              attr.data-testid="{{ urlPathId('footer.logoLink.0.url' | i18n: 'usanadotcom') }}"
              href="{{ 'footer.logoLink.0.url' | i18n: 'usanadotcom' }}"
              target="_blank"
              rel="noopener"
            >
              <img
                src="{{ 'footer.logoLink.0.image' | i18n: 'usanadotcom' }}"
                alt="{{ 'footer.logoLink.0.text' | i18n: 'usanadotcom' }}"
              />
            </a>
            @if (data.socialMediaLocale[0].social) {
              <br />
              <br />
              <div class="column-title" [innerHTML]="data.followTextLocale"></div>
              @for (social of data.socialMediaLocale; track social; let i = $index) {
                @if (hasInnerText(social.url)) {
                  <a
                    attr.data-testid="{{ urlPathId(social.url) }}"
                    href="{{ social.url }}"
                    class="social-media-footer-link"
                    target="_blank"
                    rel="noopener"
                    [attr.aria-label]="social.social"
                  >
                    <i class="fa-brands fa-lg fa-{{ social.social }}"></i>
                  </a>
                }
              }
            }
            <div class="footer-extra" [innerHTML]="data.footerExtra"></div>
          </div>
        }
      </div>
      @if (marketIn('enu-MY,zhs-MY,msa-MY')) {
        <div class="row address-container">
          <p class="col-12 col-lg-6">
            {{ 'footer.registration.title' | i18n: 'usanadotcom' }}<br />
            {{ 'footer.registration.number' | i18n: 'usanadotcom' }}
          </p>
        </div>
      }
      @if (marketIn('enu-IN')) {
        <div class="row address-container">
          <p class="col-12 col-lg-6">
            {{ 'footer.address.line1' | i18n: 'usanadotcom' }}<br />
            {{ 'footer.address.line2' | i18n: 'usanadotcom' }}<br />
            {{ 'footer.address.line3' | i18n: 'usanadotcom' }}
          </p>
          <p class="col-12 col-lg-6">
            @if ('footer.contact.email' | i18n: 'usanadotcom' | trim; as footerEmail) {
              <a target="_blank" rel="noopener" href="mailto:{{ footerEmail }}" data-testid="footer-email">
                <i class="fa-regular fa-envelope"></i>{{ footerEmail }}
              </a>
            }
            <br />
            @if ('footer.contact.phone' | i18n: 'usanadotcom' | trim; as footerPhone) {
              <a target="_blank" rel="noopener" href="tel:+{{ footerPhone }}">
                <i class="fa-regular fa-phone"></i>{{ footerPhone }}
              </a>
            }
          </p>
        </div>
      }
      <div class="text-start cookie-button-container">
        <a
          class="optanon-toggle-display cookie-settings-policy"
          [innerHTML]="data.cookiesettings"
          data-testid="cookiesettings"
        ></a>
      </div>
      @if (marketIn('enu-US,spa-US')) {
        <div class="text-start"><u-dotcom-ccpa></u-dotcom-ccpa></div>
      }
      @if (recaptchaMessage) {
        <div class="recaptcha-footer" [innerHTML]="recaptchaMessage"></div>
      }
      <div class="disclaimer">
        <div [innerHTML]="data.disclaimer1"></div>
        <div [innerHTML]="data.disclaimer2"></div>
        <div [innerHTML]="data.disclaimer3"></div>
        <div [innerHTML]="data.disclaimer4"></div>
        <div [innerHTML]="data.disclaimer5"></div>
        @for (legal of data.legal; track legal; let i = $index) {
          <div>
            @if (hasInnerText(legal.name)) {
              <a
                attr.data-testid="{{ urlPathId(legal.url) }}"
                [appLink]="legal.url"
                class="legal-link"
                target="{{ legal.target }}"
              >
                {{ legal.name }}
              </a>
            }
          </div>
        }
        @if (marketIn('jpn-JP')) {
          <a href="/pwp/files/01132015_JapanLegalPage.pdf" [translate]="'cart.jp.legal.footer'" target="_blank"></a><br>
        }
        <a [appLink]="'/ux/dotcom/dmca'" [translate]="'cart.footer.dmca.notice'"></a>
        <div
          [innerHTML]="data.adaPolicy"
          [ngClass]="{ 'ada-policy': !!data.adaPolicy }"
          data-testid="adaPolicy"
        ></div>
        <div [innerHTML]="data.copyright"></div>
      </div>
    </div>
  </div>
}
